const defaultContextKeyFilter = {
  clientName: [],
  contextKeyValue: [],
  isChildSiteLocked: [],
  childUpdateStatus: []
};

const defaultContentRegisterFilter = {
  clientIds: [],
  moduleIds: [],
  moduleNames: [],
  parentPages: [],
  pages: [],
  contentType: [],
  visible: null,
  public: null,
  lastUpdatedDate: []
};

const defaultDocumentRegisterFilter = {
  title: [],
  documentType: [],
  documentCategory: [],
  documentOwner: [],
  approvedBy: [],
  dateApproved: [],
  dateLastUpdated: [],
  groupLocked: null,
  reviewRequired: null,
  dateLastReviewed: [],
  reviewer: [],
  reviewFrequency: [],
  visible: null
};

const yesNoOptionItems = [
  {
    text: 'Yes',
    value: true
  },
  {
    text: 'No',
    value: false
  }
];

const visibilityOptionItems = [
  {
    text: 'On',
    value: true
  },
  {
    text: 'Off',
    value: false
  }
];

// Page Visibility reads as On/Off on every surface it appears on — table cell, filter
// option and exported CSV. Every other boolean register column reads as Yes/No.
const onOffBooleanFilterKeys = ['visible'];

function getBooleanFilterOptionItems(filterKey) {
  return onOffBooleanFilterKeys.includes(filterKey) ? visibilityOptionItems : yesNoOptionItems;
}

function formatBooleanRegisterValue(filterKey, value) {
  const optionItem = getBooleanFilterOptionItems(filterKey).find(
    (item) => item.value === Boolean(value)
  );
  return optionItem.text;
}

const lockStatusOptionItems = [
  {
    text: 'Yes',
    value: 'Yes'
  },
  {
    text: 'No',
    value: 'No'
  }
];

const valueStatusOptionItems = [
  {
    text: 'Complete',
    value: 'Complete'
  },
  {
    text: 'Blank',
    value: 'Blank'
  }
];

export {
  defaultContextKeyFilter,
  lockStatusOptionItems,
  valueStatusOptionItems,
  defaultContentRegisterFilter,
  defaultDocumentRegisterFilter,
  yesNoOptionItems,
  visibilityOptionItems,
  getBooleanFilterOptionItems,
  formatBooleanRegisterValue
};
